import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import CreativeImage from "./CreativeImage";
import { writeBatch, doc, collection, getDocs } from "firebase/firestore";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import { db, storage, app } from "../firebase";

import axios from "axios";
import cheerio from "cheerio";
export default function UNResolution() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [resolutions, setResolutions] = useState([]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const fetchedResolutions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "UNResultions"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const fetchedResolutions = treaties.sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setResolutions(fetchedResolutions);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };

  const FinalData = resolutions.filter((row) => row.url !== null);

  useEffect(() => {
    // const batch = writeBatch(db); // Create a batch write object
    // resolutions.forEach((treatyData) => {
    //   const newDocRef = doc(collection(db, "UNResultions")); // Create a new document reference in the "treaties" collection
    //   batch.set(newDocRef, treatyData); // Add data to the batch
    // });
    // batch.commit(); // Commit the batch
    fetchedResolutions();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,

        backgroundColor: "#212C62",
      }}
    >
      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>UN resolutions</b>
            </h1>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>UN resolutions per country : </b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Country Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {FinalData.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <a className="colorst" target="_blank" href={row.url}>
                        {row.title}
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={resolutions.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Card>
    </div>
  );
}
